import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[amberText]',
})
export class AmberTextDirective {
  @Input() amberText: boolean;

  constructor(el: ElementRef) {
    setTimeout(() => {
      if (this.amberText) {
        el.nativeElement.style.color = '#ff9900';
        el.nativeElement.style.fontWeight = 'bold';
      }
    });
  }
}
